import { useMemo } from 'react';
import { useUserBrandsQuery, useUserDetailsQuery } from '../gql/hooks';
import { authService } from '../services';
import { useRosterGroupsQuery } from '../gql/hooks/queries/useRosterGroupsQuery';

export const useSegmentation = ( ) => {
    const { data: brandsResponse, loading: brandsLoading } = useUserBrandsQuery();
    const { data: userDetailsResponse, loading: detailsLoading } = useUserDetailsQuery();
    const { data: rosterGroupsResponse, loading: groupsLoading } = useRosterGroupsQuery();

    const learningProfiles = useMemo( () => {
        return rosterGroupsResponse?.groups?.edges
            .map( e => e.node )
            .filter( n => n.attributes?.some( a => a.name == 'lms-learning-profile' ) )
            .map( n => ( { ...n.attributes.find( a => a.name == 'lms-learning-profile' ), id: n.id } ) );
    }, [ groupsLoading ] );
    
    /**
     * The IDs of the brands the user is included in.
     * @type { string[] }
     */
     const userBrandIds = useMemo( () => {
        return brandsResponse?.brands?.edges
            ?.map( ( brandEdge ) => brandEdge?.node?.id )
            ?.filter( ( brandId ) => Boolean( brandId ) )
            || [];
    }, [ brandsResponse ] );

    /**
     * The IDs of the groups the user is included in.
     * @type { string[] }
     */
    const userGroupIds = useMemo( () => {
        const userGroups = userDetailsResponse?.person?.groups || [];
        return userGroups?.map( ( groupData ) => groupData.id );
    }, [ userDetailsResponse ] );

    // const segmentFunctions = {
    //     segmentBrand: (item) => {
    //         const itemBrands = item.lxp.relatedResourceBrandIds;
    //         return itemBrands?.some(brandId => userBrandIds.includes())
    //     }
    // }

    function userCanSeeProfile( profileIds, userTags ) {
        if ( !profileIds || profileIds.length == 0 ) {
            return true;
        }

        const profileNames = learningProfiles.filter( lp => profileIds.includes( lp.id ) ).map( lp => lp.value );

        return userTags.some( t => profileNames.includes( t ) );
    }

    const segmentData = ( data ) => {
        if ( !userBrandIds || !userGroupIds || !learningProfiles || !data || data.length == 0 ) {return [];}

        const userTags = authService.getTags() || [];

        let temp = data.filter( l => l
            && l.lxp.relatedResourceBrandIds?.some( brandId => userBrandIds.includes( brandId ) )
            && l.lxp.relatedResourceCompanyRelationshipIds?.some( relId => userGroupIds.includes( relId ) )
            && l.lxp.relatedResourceLocaleIds?.some( localeId => userGroupIds.includes( localeId ) )
            && userCanSeeProfile( l[ 'learningProfileIds' ], userTags )
            && ( userTags.includes( 'employee' ) || userTags.includes( 'miyosmart' ) || l.lxp.relatedResourceProductIds.every( pId => !pId ) )
            );

        return temp;
    };

    // useEffect( () => {
    //     window.segmentExplained = () => {
    //         const userTags = authService.getTags() || [];

    //         const explanations = data.map( d => {

    //             const explanation = {
    //                 data: d,
    //                 accepted: false,
    //                 reasons: []
    //             };

    //             if ( !d ) {
    //                 explanation.reasons.push( 'Null object' );
    //                 return explanation;
    //             } 
                
    //             if ( !d.lxp.relatedResourceBrandIds?.some( brandId => userBrandIds.includes( brandId ) ) ) {
    //                 explanation.reasons.push( `Brand: user = ${ userBrandIds }` );
    //             }
                
    //             if ( !d.lxp.relatedResourceCompanyRelationshipIds?.some( relId => userGroupIds.includes( relId ) ) ) {
    //                 explanation.reasons.push( `Company Relationship: user = ${ userGroupIds }` );
    //             } 
                
    //             if ( !d.lxp.relatedResourceLocaleIds?.some( localeId => userGroupIds.includes( localeId ) ) ) {
    //                 explanation.reasons.push( `Locale: user = ${ userGroupIds }` );
    //             }

    //             if ( !userCanSeeProfile( l[ 'learningProfileIds' ], userTags ) ) {
    //                 explanation.reasons.push( `Locale: user = ${ learningProfiles }` );
    //             }

    //             if ( !( userTags.includes( 'employee' ) || userTags.includes( 'miyosmart' ) || d.lxp.relatedResourceProductIds.every( pId => !pId ) ) ) {
    //                 explanation.reasons.push( `Miyosmart/Employee: user = ${ userTags }, ${ d.lxp.relatedResourceProductIds }` );
    //             }

    //             if ( explanation.reasons.length == 0 ) {
    //                 explanation.accepted = true;
    //             }

    //             return explanation;

    //         } );

    //         console.log( explanations );
    //     };
    // }, [] );

    return useMemo( () => ( { segmentData, loading: brandsLoading || detailsLoading } ), [ userBrandIds, userGroupIds, learningProfiles ] );
};